<section class="flex flex-col gap-12">
  <app-section-header
    [description]="'Publishing performance across all platforms'"
    [icon]="'@tui.trending-up'"
    [subtitle]="'Publishing Stats'"
    [title]="'Trusted by developers worldwide'"
  >
  </app-section-header>
  <div class="flex w-full flex-col items-center gap-6">
    @let data = statistics.data();

    <div class="grid w-full grid-cols-1 gap-8 md:grid-cols-3">
      <div
        class="flex flex-col rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
      >
        <div class="mb-4 flex flex-row items-center">
          <tui-icon icon="@tui.upload-cloud" class="mr-2" />
          <span class="text-xl font-bold md:text-2xl"
            ><span
              [countUp]="data?.allTimeAppDeployments || 0"
              [options]="{ enableScrollSpy: true, scrollSpyOnce: true }"
              [reanimateOnClick]="false"
              >0</span
            >+</span
          >
        </div>
        <span class="text-balance text-lg">App Store updates deployed</span>
        <span class="text-base text-gray-500">since launch</span>
      </div>
      <div
        class="flex flex-col rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
      >
        <div class="mb-4 flex flex-row items-center">
          <tui-icon icon="@tui.store" class="mr-2" />
          <span class="text-xl font-bold md:text-2xl">3</span>
        </div>
        <span class="text-balance text-lg">App Stores supported</span>
        <span class="text-base text-gray-500">Android and iOS</span>
      </div>
      <div
        class="flex flex-col rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
      >
        <div class="mb-4 flex flex-row items-center">
          <tui-icon icon="@tui.clock" class="mr-2" />
          <span class="text-xl font-bold md:text-2xl"
            ><span
              [countUp]="0"
              [options]="{ enableScrollSpy: true, scrollSpyOnce: true }"
              [reanimateOnClick]="false"
              >0</span
            >m
            <span
              [countUp]="38"
              [options]="{ enableScrollSpy: true, scrollSpyOnce: true }"
              [reanimateOnClick]="false"
              >0</span
            >s</span
          >
        </div>
        <span class="text-balance text-lg">Average deployment time</span>
        <span class="text-base text-gray-500">to app stores</span>
      </div>
    </div>
    <span class="flex items-center gap-4 text-base text-gray-500">
      <tui-pulse [tuiAppearance]="'positive'" /><span
        >Last updated {{ data?.updatedAt | timeAgo }}</span
      >
    </span>
  </div>
</section>
